
const state = () => ({
  my: false,
  favourites: false,
  category: '',
  diagram: '',
  slide: '',
  tag: '',
  ordering: '',
  query: ''
})

const stringFilters = [
  'category', 'diagram', 'slide', 'tag', 'ordering', 'query'
]

const mutations = {
  toggleFavourites(state) {
    state.favourites = !state.favourites
  },
  toggleMy(state) {
    state.my = !state.my
  },
  setMy(state, flag) {
    state.my = flag
  },
  setCategory(state, category) {
    state.category = category
    state.tag = ''
    state.diagram = ''
    state.slide = ''
  },
  setTag(state, tag) {
    state.tag = tag
    state.category = ''
    state.diagram = ''
    state.slide = ''
  },
  setDiagram(state, diagram) {
    state.diagram = `${diagram}`
    state.tag = ''
    state.category = ''
  },
  setSlide(state, slide) {
    state.slide = `${slide}`
    state.tag = ''
    state.category = ''
  },
  setOrdering(state, ordering) {
    state.ordering = ordering
  },
  setQuery(state, query) {
    state.query = query
  },
  removeFilter(state, type) {
    if (stringFilters.includes(type)) {
      state[type] = ''
    } else {
      state[type] = false
    }
  },
  clearFiltering(state) {
    const filters = [
      'my', 'favourites', 'category', 'diagram', 'slide', 'tag', 'ordering', 'query'
    ]
    filters.forEach(filterName => {
      console.log(`Clearing ${filterName} filter`)
      if (typeof state[filterName] === 'boolean') {
        state[filterName] = false
      } else {
        state[filterName] = ''
      }
    })
  }
}

const getters = {
  isActive: (state) => (categoryId) => {
    return state.category === categoryId
  },
  filteringActive: (state) => {
    const boolFilters = [
      'my', 'favourites'
    ]
    return stringFilters.some(filterName => state[filterName] !== '') || boolFilters.some(filterName => state[filterName])
  },
  orderingLabel: (state) => {
    const orderingLabels = {
      '-created_at': 'newest',
      '-popularity': 'popular'
    }
    return orderingLabels[state.ordering]
  },
  selectedCategory: (state, getters, rootState) => {
    if (state.category) {
      const categoryDetails = rootState.categories.find(c => c.id === state.category)
      return categoryDetails ? categoryDetails.name : state.category
    } else {
      return 'All categories'
    }
  },
  activeFilters: (state, getters, rootState) => {
    const orderingLabels = {
      '-created_at': 'Newest',
      '-popularity': 'Popular'
    }
    const filters = []
    if (state.tag) {
      filters.push(
        {
          label: state.tag,
          value: state.tag,
          type: 'tag'
        }
      )
    }
    if (state.category) {
      const categoryDetails = rootState.categories.find(c => c.id === state.category)
      filters.push(
        {
          value: state.category,
          label: categoryDetails ? categoryDetails.name : state.category,
          type: 'category'
        }
      )
    }
    if (state.ordering) {
      filters.push(
        {
          value: state.ordering,
          label: orderingLabels[state.ordering],
          type: 'ordering'
        }
      )
    }
    if (state.my) {
      filters.push(
        {
          value: state.my,
          label: 'My slides',
          type: 'my'
        }
      )
    }
    if (state.favourites) {
      filters.push(
        {
          value: state.favourites,
          label: 'Favourites',
          type: 'favourites'
        }
      )
    }
    if (state.diagram) {
      filters.push(
        {
          value: state.diagram,
          label: 'diagram',
          type: 'diagram'
        }
      )
    }
    if (state.slide) {
      filters.push(
        {
          value: state.slide,
          label: 'slide',
          type: 'slide'
        }
      )
    }
    if (state.query) {
      filters.push(
        {
          value: state.query,
          label: state.query,
          type: 'query'
        }
      )
    }
    return filters
  }
}

export default { namespaced: true, state, mutations, getters }
